var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TooliabaMessage',{attrs:{"date":_vm.message.created_at}},[_c('div',{staticClass:"pa3 bodyCopy"},[_vm._v(_vm._s(_vm.message.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }